var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-carousel',{attrs:{"cycle":"","height":"600","hide-delimiter-background":"","show-arrows":false}},_vm._l((_vm.slides),function(slide,i){return _c('v-carousel-item',{key:i,staticClass:"bloc",attrs:{"src":_vm.slides[i].src}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }